import { Fragment } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import ProjectSectionHome from '../../components/ProjectSection/ProjectSectionHome'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation'
import ServiceHomeSection from '../../components/ServiceSection/ServiceHomeSection'
import About from '../../components/about/about'
import Hero from '../../components/hero/hero'

import CtaSection from '../../components/CtaSection/CtaSection'
import RiskSection from '../../components/Risk/RiskSection'
import Testimonial from '../../components/Testimonial/Testimonial'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo-2.png'

const HomePage = () => {
  return (
    <Fragment>
      <Navbar
        hclass={'wpo-site-header wpo-header-style'}
        Logo={Logo}
        col1={'col-lg-3 col-md-1 col-2 d-lg-none dl-block'}
        col2={'col-lg-5 col-md-11 col-10'}
        col3={'col-lg-7 col-md-1 col-1'}
        col4={'col-lg-2 col-md-2 col-2'}
      />
      <Hero />
      <ScrollTextAnimation />
      <About hclass={'wpo-about-section section-padding pb-0'} />
      <ServiceHomeSection hclass={'wpo-service-section'} />
      <Testimonial hclass={'wpo-testimonial-section'} />
      <RiskSection hclass={'who-risk-section section-padding pb-0'}/>
      <ProjectSectionHome hclass={'wpo-project-section section-padding'} />
<CtaSection hclass={'who-cat-section section-padding pb-0'}/>
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}

export default HomePage
